export default __webpack_public_path__ + "static/media/latin1.a14c7fd3.webp";